// @ts-nocheck

import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { getNominative } from '../../../common/utils'
import { DocumentItem } from '../DocumentItem'
import { SectionHeader } from '../SectionHeader'

const groupBySubCategory = (list) => {
  return _.chain(list)
    .orderBy('name')
    .groupBy('subCategory')
    .map((documents, subCategory) => ({
      subCategory:
        !subCategory || subCategory === 'undefined' ? null : subCategory,
      documents
    }))
    .orderBy('subCategory', 'desc')

    .value()
}

const DocumentList = ({
  documents,
  onDelete,
  onEdit,
  carePlanNominative,
  testId
}) => {
  return (
    <div>
      {Object.keys(documents).map((categoryName, index) => {
        const list = groupBySubCategory(documents[categoryName])
        const isCarePlanDocuments = list[0] && list[0].attachedToCarePlan
        const containerStyle =
          index === 0 ? { ...styles.container, marginTop: 0 } : styles.container

        return (
          <div key={categoryName} style={containerStyle}>
            <SectionHeader
              title={categoryName}
              subtitle={
                isCarePlanDocuments && getCarePlansNote(carePlanNominative)
              }
            />
            <div style={styles.list}>
              {list.map(({ subCategory, documents }) => (
                <div>
                  {subCategory ? (
                    <div style={styles.subCategory}>
                      <SectionHeader
                        isSubSection
                        greyLine
                        title={subCategory}
                      />
                    </div>
                  ) : null}
                  {documents.map((document) => (
                    <DocumentItem
                      data={document}
                      key={document.id}
                      onDelete={onDelete}
                      onEdit={onEdit}
                      readOnly={document.attachedToCarePlan}
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

const getCarePlansNote = (carePlanNominative) =>
  `To edit these documents you must review the ${getNominative(
    carePlanNominative,
    'Care Plans'
  )} they are attached to.`

const styles = {
  container: {
    margin: '40px 0px'
  },
  list: {
    listStyle: 'none',
    listStyleType: 'none',
    padding: 0
  },
  subCategory: {
    marginTop: 28
  }
}

DocumentList.propTypes = {
  documents: PropTypes.object,
  listId: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  testId: PropTypes.string
}

export default DocumentList
